"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NurseShiftCancellationReason = void 0;
exports.instanceOfNurseShiftCancellationReason = instanceOfNurseShiftCancellationReason;
exports.NurseShiftCancellationReasonFromJSON = NurseShiftCancellationReasonFromJSON;
exports.NurseShiftCancellationReasonFromJSONTyped = NurseShiftCancellationReasonFromJSONTyped;
exports.NurseShiftCancellationReasonToJSON = NurseShiftCancellationReasonToJSON;
exports.NurseShiftCancellationReasonToJSONTyped = NurseShiftCancellationReasonToJSONTyped;
/**
 *
 * @export
 */
exports.NurseShiftCancellationReason = {
    Illness: 'ILLNESS',
    Personal: 'PERSONAL',
    SchedulingError: 'SCHEDULING_ERROR',
    OverHours: 'OVER_HOURS',
    ExpiredCredentials: 'EXPIRED_CREDENTIALS',
    Other: 'OTHER'
};
function instanceOfNurseShiftCancellationReason(value) {
    for (const key in exports.NurseShiftCancellationReason) {
        if (Object.prototype.hasOwnProperty.call(exports.NurseShiftCancellationReason, key)) {
            if (exports.NurseShiftCancellationReason[key] === value) {
                return true;
            }
        }
    }
    return false;
}
function NurseShiftCancellationReasonFromJSON(json) {
    return NurseShiftCancellationReasonFromJSONTyped(json, false);
}
function NurseShiftCancellationReasonFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function NurseShiftCancellationReasonToJSON(value) {
    return value;
}
function NurseShiftCancellationReasonToJSONTyped(value, ignoreDiscriminator) {
    return value;
}
//# sourceMappingURL=NurseShiftCancellationReason.js.map